export default [
  {
  	id: 1,
    text: '1. Вам письмо с предупреждением от Роскомнадзора: один из материалов нарушает российское законодательство. Как поступить?',
    answers: [
      {
      	id: 1,
        text: 'Отредактировать статью.',
        results: [
          {
          	id: 1,
            text: 'Новая редакция статьи удовлетворила надзорный орган, блокировка не установлена.',
            effects: [0, 0],// первое — аудитория, второе — деньги
          },
          {
          	id: 2,
            text: 'Новая редакция статьи не удовлетворила надзорный орган, установлена блокировка.',
            effects: [-3, -1],
          },
          {
          	id: 3,
            text: 'Новая редакция статьи удовлетворила надзорный орган, блокировка не установлена. Новость в соцсетях о поступившем предупреждении стимулировала интерес к сайту.',
            effects: [1, 1],
          },
        ]
      },
      {
      	id: 2,
        text: 'Никак не реагировать.',
        results: [
          {
          	id: 1,
            text: 'По каким-то причинам надзорный орган не стал устанавливать блокировку.',
            effects: [0, 0],
          },
          {
          	id: 2,
            text: 'Надзорный орган блокирует сайт.',
            effects: [-3, -1],
          },
          {
          	id: 3,
            text: 'Новость в соцсетях о поступившем предупреждении вместе с неожиданным ростом использования анонимайзеров в русскоязычном сегменте интернета стимулирует интерес к сайту.',
            effects: [1, 1],
          },
        ]
      },
      {
      	id: 3,
        text: 'Удалить статью.',
        results: [
          {
          	id: 1,
            text: 'Блокировка не установлена. Новость в соцсетях о поступившем предупреждении стимулировала интерес к сайту.',
            effects: [1, 1],
          },
          {
          	id: 2,
            text: 'Надзорный орган удовлетворён, блокировка не установлена.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'По каким-то причинам надзорный орган устанавливает блокировку.',
            effects: [-3, -1],
          },
        ]
      },
      {
      	id: 4,
        text: 'Обжаловать решение Роскомнадзора.',
        results: [
          {
          	id: 1,
            text: 'Жалоба рассмотрена, решение надзорного органа признано правомерным. Установлена блокировка сайта.',
            effects: [-3, -1],
          },
          {
          	id: 2,
            text: 'Решение надзорного органа признано неправомерным. Новость в соцсетях о поступившем предупреждении и его успешном обжаловании стимулировала интерес к сайту.',
            effects: [1, 1],
          },
          {
          	id: 3,
            text: 'После длительных и дорогостоящих юридических консультаций, а также нескольких апелляций решение надзорного органа признано неправомерным.',
            effects: [0, -1],
          },
        ]
      },
    ]
  },
  {
  	id: 2,
    text: '2. Материалы сайта всё чаще копируют на сторонних ресурсах и в соцсетях, источник при этом не указывается. Что делать?',
    answers: [
      {
      	id: 1,
        text: 'По каждому обнаруженному случаю обращаться к владельцу ресурса, просить ставить ссылку на первоисточник.',
        results: [
          {
          	id: 1,
            text: 'Большинство соглашается указать первоисточник либо удаляет неправомерно размещённые материалы.',
            effects: [1, 0],
          },
          {
          	id: 2,
            text: 'Практически никто не реагирует на такие обращения.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Некоторые соглашаются указать ссылку на первоисточник, некоторые удаляют материалы.',
            effects: [0, 0],
          },
        ]
      },
      {
      	id: 2,
        text: 'Отправлять жалобы хостинг-провайдерам и администрации социальных сетей на нарушение авторских прав.',
        results: [
          {
          	id: 1,
            text: 'Жалобы проигнорированы.',
            effects: [0, 0],
          },
          {
          	id: 2,
            text: 'Нарушающие ваши авторские права ресурсы блокируют.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Жалобы проигнорированы. Новость в соцсетях о сложившейся ситуации стимулирует интерес к сайту.',
            effects: [1, 0],
          },
        ]
      },
      {
      	id: 3,
        text: 'Никак не реагировать.',
        results: [
          {
          	id: 1,
            text: 'Ни позитивных, ни негативных изменений это не вызывает.',
            effects: [0, 0],
          },
          {
          	id: 2,
            text: 'Ни позитивных, ни негативных изменений это не вызывает.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Странно, но, кажется, посетители других ресурсов сами начинают искать первоисточник, заинтересовавшись скопированным контентом.',
            effects: [2, 1],
          },
        ]
      },
      {
      	id: 4,
        text: 'Подать судебный иск.',
        results: [
          {
          	id: 1,
            text: 'Несмотря на немалые затраты на юристов, иск не удовлетворён.',
            effects: [0, -2],
          },
          {
          	id: 2,
            text: 'Иск удовлетворен.',
            effects: [1, 1],
          },
          {
          	id: 3,
            text: 'Несмотря на немалые затраты на юристов, иск не удовлетворен. Этот информационный повод стимулирует интерес к сайту.',
            effects: [1, -1],
          },
        ]
      },
    ]
  },
  {
  	id: 3,
    text: '3. Более 30% писем еженедельной рассылки стали попадать в папку «Спам» в почтовых ящиках подписчиков.',
    answers: [
      {
      	id: 1,
        text: 'Ничего не делать.',
        results: [
          {
          	id: 1,
            text: 'Сервис почтовой рассылки внёс изменения в собственные алгоритмы.',
            effects: [1, 0],
          },
          {
          	id: 2,
            text: 'Письма продолжают попадать в папку «Спам».',
            effects: [-1, 0],
          },
          {
          	id: 3,
            text: 'Письма продолжают попадать в папку «Спам».',
            effects: [-1, 0],
          },
        ]
      },
      {
      	id: 2,
        text: 'Начать использовать другой сервис почтовой рассылки.',
        results: [
          {
          	id: 1,
            text: 'Сервис более дорогой, но письма еженедельной рассылки перестали попадать в папку «Спам».',
            effects: [1, -1],
          },
          {
          	id: 2,
            text: 'Это не изменило ситуацию.',
            effects: [0, -1],
          },
          {
          	id: 3,
            text: 'Письма стали попадать в папку «Спам» у ещё большего числа подписчиков.',
            effects: [-1, -1],
          },
        ]
      },
      {
      	id: 3,
        text: 'Собственное решение для почтовой рассылки должно устранить проблему.',
        results: [
          {
          	id: 1,
            text: 'Специалисты нанятой аутсорсинговой компании создали решение, минимизирующее попадание писем рассылки в «Спам».',
            effects: [0, -1],
          },
          {
          	id: 2,
            text: 'Разработка специалистов нанятой аутсорсинговой компании не решила проблему.',
            effects: [-1, -1],
          },
          {
          	id: 3,
            text: 'Силами собственного отдела разработки создано решение, минимизирующее попадание писем рассылки в «Спам».',
            effects: [0, 0],
          },
        ]
      },
      {
      	id: 4,
        text: 'Отказаться от почтовой рассылки.',
        results: [
          {
          	id: 1,
            text: 'Сэкономленные средства вложили в другие каналы распространения контента. Это сгладило негативные последствия отказа от почтовой рассылки.',
            effects: [0, 0],
          },
          {
          	id: 2,
            text: 'Некритичное сокращение посещаемости.',
            effects: [-1, 1],
          },
          {
          	id: 3,
            text: 'Некритичное сокращение посещаемости.',
            effects: [-1, 1],
          },
        ]
      },
    ]
  },
  {
  	id: 4,
    text: '4. Увеличение популярности сайта повлекло за собой увеличение времени загрузки страниц. Что делать?',
    answers: [
      {
      	id: 1,
        text: 'Ничего не делать.',
        results: [
          {
          	id: 1,
            text: 'Читатели устают ждать и отдают предпочтение сайтам с более быстрой загрузкой.',
            effects: [-2, -1],
          },
          {
          	id: 2,
            text: 'По неизвестным причинам скорость загрузки страниц стабилизировалась.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Сосредоточившись на качестве материалов, вы наращиваете лояльное ядро аудитории, готовое мириться с долгой загрузкой ради уникального контента.',
            effects: [0, 1],
          },
        ]
      },
      {
      	id: 2,
        text: 'Поставить веб-разработчикам задачу по оптимизации кода.',
        results: [
          {
          	id: 1,
            text: 'Несмотря на потраченное время, добиться положительного эффекта не удалось.',
            effects: [-1, -1],
          },
          {
          	id: 2,
            text: 'Проблема решена, время загрузки страниц значительно сократилось.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Время загрузки страниц сократилось, но незначительно.',
            effects: [-1, 0],
          },
        ]
      },
      {
      	id: 3,
        text: 'Приобрести дополнительные серверные мощности.',
        results: [
          {
          	id: 1,
            text: 'Скорость загрузки страниц нормализована.',
            effects: [0, -1],
          },
          {
          	id: 2,
            text: 'Скорость загрузки страниц нормализована, приобретённые мощности излишни при текущей посещаемости.',
            effects: [0, -2],
          },
          {
          	id: 3,
            text: 'По каким-то причинам скорость загрузки страниц не изменилась.',
            effects: [-1, -1],
          },
        ]
      },
      {
      	id: 4,
        text: 'Ограничить количество показываемых одному пользователю страниц за сеанс, введя пейволл.',
        results: [
          {
          	id: 1,
            text: 'Нововведение не вызвало негатива у большей части аудитории, при этом нагрузка на сервер сократилась, ускорив загрузку сайта.',
            effects: [0, 1],
          },
          {
          	id: 2,
            text: 'Это решение не ускорило загрузку страниц.',
            effects: [-2, 0],
          },
          {
          	id: 3,
            text: 'Не удалось добиться значительного сокращения времени загрузки. Большая часть аудитории негативно восприняла нововведения.',
            effects: [-2, -1],
          },
        ]
      },
    ]
  },
  {
  	id: 5,
    text: '5. Жалоба от SMM-отдела: Facebook заблокировала одно из видео в вашем паблике. Предположительно, проблема в аудиодорожке.',
    answers: [
      {
      	id: 1,
        text: 'Продолжить размещать аналогичный контент.',
        results: [
          {
          	id: 1,
            text: 'Facebook блокирует возможность публикации на 3 дня.',
            effects: [-1, 0],
          },
          {
          	id: 2,
            text: 'По каким-то причинам повторной блокировки не последовало.',
            effects: [1, 1],
          },
          {
          	id: 3,
            text: 'Facebook блокирует следующее опубликованное видео, но блокировка аккаунта не последовала.',
            effects: [0, 0],
          },
        ]
      },
      {
      	id: 2,
        text: 'Удалить первоначальную версию и разместить видео с другим музыкальным сопровождением.',
        results: [
          {
          	id: 1,
            text: 'Блокировка не повторяется.',
            effects: [1, 0],
          },
          {
          	id: 2,
            text: 'Неожиданно высокий интерес к новой видеозаписи, большое количество репостов.',
            effects: [2, 0],
          },
          {
          	id: 3,
            text: 'Facebook блокирует следующее опубликованное видео, возможность публикации ограничена на 3 дня.',
            effects: [-1, 0],
          },
        ]
      },
      {
      	id: 3,
        text: 'Удалить видео и на время перестать публиковать что-либо в Facebook.',
        results: [
          {
          	id: 1,
            text: 'Сокращение переходов на сайт из социальной сети.',
            effects: [-2, 0],
          },
          {
          	id: 2,
            text: 'Ничего не произошло.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Снижение активности в социальной сети негативно влияет на посещаемость сайта.',
            effects: [-1, 0],
          },
        ]
      },
      {
      	id: 4,
        text: 'Публиковать материалы, которые содержат исключительно редакционный контент.',
        results: [
          {
          	id: 1,
            text: 'Текстовую и визуальную составляющие аудитория оценивает по-прежнему довольно хорошо, но музыкальный талант вашего сеошника признаёт только его мама.',
            effects: [-1, 0],
          },
          {
          	id: 2,
            text: 'Аудитория заинтересована новым форматом, рост популярности паблика, увеличение числа переходов с него.',
            effects: [2, 1],
          },
          {
          	id: 3,
            text: 'Блокировка не повторяется.',
            effects: [1, 0],
          },
        ]
      },
    ]
  },
  {
  	id: 6,
    text: '6. Поступило письмо на почту: большой рекламный бюджет за размещение на вашем сайте готова потратить компания, ведущая бизнес с сомнительной репутацией. Каким будет ответ?',
    answers: [
      {
      	id: 1,
        text: '«Почему бы и нет, присылайте бриф.»',
        results: [
          {
          	id: 1,
            text: 'Часть аудитории воспринимает материал негативно и принципиально не возвращается на сайт.',
            effects: [-1, 3],
          },
          {
          	id: 2,
            text: 'Деньги заплачены, аудитория встретила материал без большого негатива.',
            effects: [0, 3],
          },
          {
          	id: 3,
            text: 'Значительная часть аудитории воспринимает материал негативно и принципиально не возвращается на сайт. Узнав о размещении, некоторые рекламодатели отказываются от совместных проектов.',
            effects: [-2, 0],
          },
        ]
      },
      {
      	id: 2,
        text: 'Игнорировать письмо и ничего не отвечать.',
        results: [
          {
          	id: 1,
            text: 'Ничего не произошло.',
            effects: [0, 0],
          },
          {
          	id: 2,
            text: 'Рекламодатель аффилирован с другими компаниями, размещающими рекламные материалы на сайте. Молчание оскорбило его, часть рекламных размещений отменена.',
            effects: [0, -1],
          },
          {
          	id: 3,
            text: 'Пост с обсуждением ситуации в соцсетях стимулирует кратковременное повышение интереса к сайту.',
            effects: [1, 0],
          },
        ]
      },
      {
      	id: 3,
        text: 'Ответить отказом, обосновать свою позицию.',
        results: [
          {
          	id: 1,
            text: 'Рекламодатель аффилирован с другими компаниями, размещающими рекламные материалы на сайте. В ответ на отказ эти компании не продлевают договорные отношения.',
            effects: [0, -1],
          },
          {
          	id: 2,
            text: 'Рекламодатель спокойно воспринял отказ, проявив уважение к редакционной политике.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Обсуждение ситуации в соцсетях стимулирует кратковременное повышение интереса к сайту.',
            effects: [1, 0],
          },
        ]
      },
      {
      	id: 4,
        text: 'Согласиться, но обозначить собственные условия. Например, рассказать только о самом рекламодателе, но не о его услугах.',
        results: [
          {
          	id: 1,
            text: 'Деньги заплачены, аудитория встретила материал без большого негатива.',
            effects: [0, 3],
          },
          {
          	id: 2,
            text: 'Так или иначе, это реклама бизнеса с сомнительной репутацией. Часть аудитории воспринимает материал негативно и принципиально не возвращается на сайт.',
            effects: [-1, 3],
          },
          {
          	id: 3,
            text: 'Узнав о размещении, часть рекламодателей отказывается от совместных проектов. Обсуждение ситуации в соцсетях стимулирует кратковременное повышение интереса к сайту.',
            effects: [1, 0],
          },
        ]
      },
    ]
  },
  {
  	id: 7,
    text: '7. Читатели жалуются на баннерную рекламу на сайте. Что-то предпримете?',
    answers: [
      {
      	id: 1,
        text: 'Сократить количество баннерных мест.',
        results: [
          {
          	id: 1,
            text: 'Значительное сокращение доходов от показов рекламы.',
            effects: [0, -3],
          },
          {
          	id: 2,
            text: 'Такой шаг негативно повлиял на доходы от показов рекламы.',
            effects: [0, -1],
          },
          {
          	id: 3,
            text: 'Ничего не произошло.',
            effects: [0, 0],
          },
        ]
      },
      {
      	id: 2,
        text: 'Ничего не менять.',
        results: [
          {
          	id: 1,	
            text: 'Всё по-прежнему.',
            effects: [0, 0],
          },
          {
          	id: 2,
            text: 'Некоторая часть аудитории принципиально отказывается от посещения сайта.',
            effects: [-1, 0],
          },
          {
          	id: 3,
            text: 'Повышение качества материалов увеличивает количество их просмотров. Рост прибыли от баннерной рекламы.',
            effects: [0, 1],
          },
        ]
      },
      {
      	id: 3,
        text: 'Оставить количество баннерных мест прежним, но сократить перечень рекламируемых отраслей.',
        results: [
          {
          	id: 1,
            text: 'Повышение качества материалов увеличивает количество их просмотров. Рост прибыли от баннерной рекламы.',
            effects: [0, 1],
          },
          {
          	id: 2,
            text: 'Ничего не изменилось.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Некоторая часть аудитории не удовлетворена решением и принципиально отказывается от посещения сайта.',
            effects: [-1, 0],
          },
        ]
      },
      {
      	id: 4,
        text: 'Увеличить количество баннерных мест на сайте.',
        results: [
          {
          	id: 1,
            text: 'Некоторая часть аудитории принципиально отказывается от посещения сайта.',
            effects: [-1, 3],
          },
          {
          	id: 2,
            text: 'Некоторая часть аудитории принципиально отказывается от посещения сайта. Значительного роста доходов от показов рекламы не происходит.',
            effects: [-1, 1],
          },
          {
          	id: 3,
            text: 'Значительное увеличение доходов от показов рекламы.',
            effects: [0, 4],
          },
        ]
      },
    ]
  },
   {
   	id: 8,
    text: '8. Новый дизайн сайта негативно комментирует часть аудитории. Будете что-то делать?',
    answers: [
      {
      	id: 1,
        text: 'Выпустить пост с обоснованием преимуществ нового дизайна.',
        results: [
          {
          	id: 1,
            text: 'Активное обсуждение ситуации перешло в соцсети и стимулировало повышение интереса к сайту.',
            effects: [2, 0],
          },
          {
          	id: 2,
            text: 'Объяснения восприняты аудиторией, негативных комментариев всё меньше.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Дискуссия вызвала дополнительный интерес к сайту.',
            effects: [1, 0],
          },
        ]
      },
      {
      	id: 2,
        text: 'Банить всех негативно отзывающихся о редизайне.',
        results: [
          {
          	id: 1,
            text: 'Значительная часть аудитории негативно отнеслась к подобным действиям и принципиально не возвращается на сайт.',
            effects: [-2, 0],
          },
          {
          	id: 2,
            text: 'Обсуждение довольно быстро затухает.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Активное обсуждение в социальных сетях таких неоднозначных действий стимулирует повышение интереса к сайту.',
            effects: [1, 0],
          },
        ]
      },
      {
      	id: 3,
        text: 'Вернуть прежний дизайн.',
        results: [
          {
          	id: 1,
            text: 'Вложенные впустую средства вряд ли удастся быстро окупить',
            effects: [0, -2],
          },
          {
          	id: 2,
            text: 'Пользователи-ретрограды счастливы, но каких-то ещё существенных изменений это решение не вызвало.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Пользователи отдают предпочтение сайтам, которые следуют трендам и поддерживают новые технологии, а не цепляются за устаревшие стандарты.',
            effects: [-1, 0],
          },
        ]
      },
      {
      	id: 4,
        text: 'Ничего не делать.',
        results: [
          {
          	id: 1,
            text: 'Активное обсуждение редизайна переходит в социальные сети и провоцирует дополнительный интерес к сайту.',
            effects: [1, 0],
          },
          {
          	id: 2,
            text: 'Ничего не делаете — ничего не меняется.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Активное обсуждение редизайна переходит в соцсети и стимулирует повышение интереса к сайту.',
            effects: [2, 0],
          },
        ]
      },
    ]
  },
   {
   	id: 9,
    text: '9. Весьма именитый (но дорогой) специалист проявляет интерес к работе на вашем ресурсе на вакантной позиции. Каким будет решение?',
    answers: [
      {
      	id: 1,
        text: 'Сократить расходы на бесплатные обеды и печенье в офисе. Отправить именитому специалисту предложение о работе.',
        results: [
          {
          	id: 1,
            text: 'Предложение принято — повышение эффективности работы редакции, рост качества материалов.',
            effects: [2, -1],
          },
          {
          	id: 2,
            text: 'Большая часть редакции демотивирована нововведениями, что негативно сказывается на качестве материалов.',
            effects: [-1, -2],
          },
          {
          	id: 3,
            text: 'Предложение принято. Никаких существенных изменений в работе редакции.',
            effects: [0, -2],
          },
        ]
      },
      {
      	id: 2,
        text: 'Уволить несколько наименее эффективных сотрудников, чьи зарплаты суммарно равны ожидаемому именитым специалистом окладу. Отправить предложение о работе.',
        results: [
          {
          	id: 1,
            text: 'Предложение принято. Повышение эффективности работы редакции, рост качества материалов.',
            effects: [2, 0],
          },
          {
          	id: 2,
            text: 'Часть редакции демотивирована нововведениями, что негативно сказывается на качестве материалов.',
            effects: [-1, -1],
          },
          {
          	id: 3,
            text: 'Предложение отклонено.',
            effects: [0, 0],
          },
        ]
      },
      {
      	id: 3,
        text: 'Состав команды не меняется. Необходимости в именитом специалисте нет.',
        results: [
          {
          	id: 1,
            text: 'Это ваше решение.',
            effects: [0, 0],
          },
          {
          	id: 2,
            text: 'Ничего не происходит.',
            effects: [0, 0],
          },
          {
          	id: 3,
            text: 'Часть редакции, ожидавшая приход нового сотрудника, демотивирована. Это негативно сказывается на качестве контента. ',
            effects: [-1, 0],
          },
        ]
      },
      {
      	id: 4,
        text: 'Отправить предложение работы.',
        results: [
          {
          	id: 1,
            text: 'Предложение принято. Заметного роста качества материалов не происходит.',
            effects: [0, -2],
          },
          {
          	id: 2,
            text: 'Предложение принято — повышение качества материалов, которое влечёт за собой рост аудитории.',
            effects: [2, -2],
          },
          {
          	id: 3,
            text: 'Формат работы нового сотрудника не принят остальной частью редакции, что порождает внутренние конфликты и снижает качество материалов.',
            effects: [-1, -2],
          },
        ]
      },
    ]
  },
  {
  	id: 10,
    text: '10. Редакция жалуется на неудобство и медленную работу внутренней административной панели. Ваши действия?',
    answers: [
      {
      	id: 1,
        text: 'На рынке есть готовые альтернативные решения — заплатить и попробовать.',
        results: [
          {
          	id: 1,
            text: 'Приобретён довольно дорогостоящий вариант. Качество контента никак не изменилось.',
            effects: [0, -2],
          },
          {
          	id: 2,
            text: 'Новый инструмент позволил заметно повысить качество материалов и скорость их выхода, что положительно повлияло на рост аудитории.',
            effects: [2, -2],
          },
          {
          	id: 3,
            text: 'Увеличение качества и скорости выхода материалов отмечены не только аудиторией, но и новыми крупными рекламодателями.',
            effects: [2, 0],
          },
        ]
      },
      {
      	id: 2,
        text: 'Силами собственного отдела веб-разработки спроектировать инструмент под нужды редакции.',
        results: [
          {
          	id: 1,
            text: 'Загруженность разработчиков негативно сказывается на сроках подготовки рекламных проектов. Несколько рекламодателей отказываются от размещения.',
            effects: [0, -1],
          },
          {
          	id: 2,
            text: 'Улучшение работы админки положительно сказалось на качестве материалов, но загруженность разработчиков помешала выполнить обязательства по срокам подготовки нескольких рекламных проектов.',
            effects: [1, -1],
          },
          {
          	id: 3,
            text: 'Повышение удобства работы с админкой положительно сказывается на контенте, что вызывает рост аудитории.',
            effects: [1, 0],
          },
        ]
      },
      {
      	id: 3,
        text: 'Подготовить техническое задание с учётом нюансов работы редакции и отдать разработку ПО на аутсорс.',
        results: [
          {
          	id: 1,
            text: 'Новый инструмент получился недешёвым, но позволил заметно повысить качество материалов и скорость их выхода, что положительно повлияло на рост аудитории.',
            effects: [2, -2],
          },
          {
          	id: 2,
            text: 'Решение стороннего разработчика имеет запутанную структуру и долгое время отклика, что негативно влияет на качество материалов и сроки их выхода.',
            effects: [-1, -2],
          },
          {
          	id: 3,
            text: 'Приобретён довольно дорогостоящий вариант. Качество контента никак не изменилось, несмотря на положительные отзывы редакции о новой админке.',
            effects: [0, -2],
          },
        ]
      },
      {
      	id: 4,
        text: 'Ничего не делать.',
        results: [
          {
          	id: 1,
            text: 'Ничего не происходит.',
            effects: [0, 0],
          },
          {
          	id: 2,
            text: 'Превозмогая трудности, редакция оттачивает свой опыт и повышает качество контента. Рост аудитории.',
            effects: [1, 0],
          },
          {
          	id: 3,
            text: 'Постоянные проблемы с рабочим инструментом негативно сказываются на работе редакции и качестве контента, что не может не отметить аудитория.',
            effects: [-2, 0],
          },
        ]
      },
    ]
  }
]


// WEBPACK FOOTER //
// ./src/data/questions.js